import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Form } from 'react-bootstrap';
import BasicBox from '../packages/BasicBox';
import DeluxeBox from '../packages/DeluxeBox';
import PremierBox from '../packages/PremierBox';
import PackageList from '../packages/PackageList';
import { isMobileOnly } from 'react-device-detect';
import PremierBox2 from '../packages/PremierBox2';
import DeluxeBox2 from '../packages/DeluxeBox2';
import BasicBox2 from '../packages/BasicBox2';
import BasicBox3 from '../packages/BasicBox3';
import { useRouter } from 'next/dist/client/router';
import styled from 'styled-components';
import FAQPackage from '../FAQPackage';

const StyledBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 32px;
  gap: 16px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
export default function TrademarkStep4({
  state,
  onChange,
  validated,
  registerTrademarkList,
}) {
  const router = useRouter();

  const isV2 = router.pathname.includes('registration-trademark-2');
  const handleChange = (e) => {
    const event = { target: { name: 'option', value: e } };
    onChange(event);
  };
  return (
    <div className="question packages">
      {isMobileOnly && isV2 && (
        <div>
          <h2>Choose a package.</h2>
          <Typography className="regular">
            All packages include lifetime customer support and our 100%
            satisfaction guaranteed.
          </Typography>
          {registerTrademarkList ? (
            <div className="box-wrapper">
              <PremierBox2
                selected={state.option === 'PREMIER'}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'PREMIER'
                  )[0].price
                }
                onChange={handleChange}
              />
              <DeluxeBox2
                selected={state.option === 'DELUXE'}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'DELUXE'
                  )[0].price
                }
                onChange={handleChange}
              />
              <BasicBox2
                selected={state.option === 'BASIC'}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'BASIC'
                  )[0].price
                }
                onChange={handleChange}
              />
            </div>
          ) : (
            ''
          )}
          {/* next form hided using css (.reg .packages #TrademarkForm) */}
          <Form id="TrademarkForm" noValidate validated={validated}></Form>
        </div>
      )}
      {!isV2 && (
        <div>
          <h2>Choose a package.</h2>
          <Typography className="regular">
            All packages include lifetime customer support and our 100%
            satisfaction guaranteed.
          </Typography>
          {registerTrademarkList && (
            <StyledBoxContainer>
              <BasicBox3
                selected="BASIC"
                name="Basic"
                topContainer={{ title: <>&nbsp;</>, color: 'white' }}
                items={[
                  {
                    header: '14 day processing time',
                    isBlue: false,
                    text: 'We will complete your search within 14 business days, and file the application after you have approved it.',
                  },
                  {
                    header: 'Trademark Monitoring',
                    isBlue: false,
                    text: (
                      <>
                        <span>1 Month</span> of free trademark monitoring
                        included to ensure no infringements on your mark are
                        filed.
                      </>
                    ),
                  },
                  {
                    header: 'Prepare & Reviewed by Our Specialists',
                    isBlue: false,
                    text: 'Have peace of mind knowing our specialists will research your mark, file for you, and deal with minor roadblocks',
                  },
                  {
                    header: '100% Satisfaction Guaranteed',
                    isBlue: false,
                    text: '',
                  },
                ]}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'BASIC'
                  )[0].price
                }
                onChange={handleChange}
              />
              <BasicBox3
                selected="DELUXE"
                name="Standard"
                topContainer={{ title: 'MOST POPULAR', color: '#3498DB' }}
                items={[
                  {
                    header: 'Cease & Desist Letter',
                    isBlue: true,
                    text: (
                      <>
                        In the event that you find an infringing mark, we will
                        provide a Cease and Desist template for you to deliver
                        to your infringing party.
                      </>
                    ),
                  },
                  {
                    header: 'Trademark Monitoring',
                    isBlue: false,
                    text: (
                      <>
                        <span>1 Month</span> of free trademark monitoring
                        included to ensure no infringements on your mark are
                        filed.
                      </>
                    ),
                  },
                  {
                    header: 'Prepare & Reviewed by Our Specialists',
                    isBlue: false,
                    text: 'Have peace of mind knowing our specialists will research your mark, file for you, and deal with minor roadblocks',
                  },
                  {
                    header: '100% Satisfaction Guaranteed',
                    isBlue: false,
                    text: '',
                  },
                ]}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'DELUXE'
                  )[0].price
                }
                onChange={handleChange}
              />
              <BasicBox3
                selected="PREMIER"
                name="Premier"
                topContainer={{ title: 'FASTEST SERVICE', color: 'black' }}
                items={[
                  {
                    header: 'Handle Additional Filings',
                    isBlue: true,
                    text: (
                      <>
                        60% of trademark applications require additional filings
                        for approval.{' '}
                        <span>We handle additional filings for you.</span>
                      </>
                    ),
                  },
                  {
                    header: 'Trademark Monitoring',
                    isBlue: false,
                    text: (
                      <>
                        <span>1 Month</span> of free trademark monitoring
                        included to ensure no infringements on your mark are
                        filed.
                      </>
                    ),
                  },
                  {
                    header: 'Prepare & Reviewed by Our Specialists',
                    isBlue: false,
                    text: 'Have peace of mind knowing our specialists will research your mark, file for you, and deal with minor roadblocks',
                  },
                  {
                    header: '100% Satisfaction Guaranteed',
                    isBlue: false,
                    text: '',
                  },
                  {
                    header: 'Cease & Desist Letter',
                    isBlue: false,
                    text: 'In the event that you find an infringing mark, we will provide a Cease and Desist template for you to deliver to your infringing party.',
                  },
                ]}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'PREMIER'
                  )[0].price
                }
                onChange={handleChange}
              />
            </StyledBoxContainer>
          )}
          {registerTrademarkList && (
            <div className="box-wrapper">
              <PackageList
                registerTrademarkList={registerTrademarkList}
                isV3={true}
              />
            </div>
          )}
          <FAQPackage />
          {/* next form hided using css (.reg .packages #TrademarkForm) */}
          <Form id="TrademarkForm" noValidate validated={validated}></Form>
        </div>
      )}
      {!isMobileOnly && isV2 && (
        <div>
          <h2
            style={{
              textAlign: 'center',
              fontFamily: 'MontserratBold',
              fontSize: '1.8em',
              lineHeight: '1.3em',
              marginBottom: '15px',
              marginTop: '0px',
            }}
          >
            Choose a Package That Works for You
          </h2>
          <Typography
            className="regular"
            style={{
              textAlign: 'center',
              fontFamily: 'MontserratRegular',
              fontSize: '1.15em',
              marginBottom: '40px',
              color: '#7B848D',
            }}
          >
            All packages include our professional monitoring & filing service
          </Typography>
          {registerTrademarkList && (
            <div className="box-wrapper">
              <BasicBox
                selected={state.option === 'BASIC'}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'BASIC'
                  )[0].price
                }
                onChange={handleChange}
              />
              <DeluxeBox
                selected={state.option === 'DELUXE'}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'DELUXE'
                  )[0].price
                }
                onChange={handleChange}
              />
              <PremierBox
                selected={state.option === 'PREMIER'}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'PREMIER'
                  )[0].price
                }
                onChange={handleChange}
              />
            </div>
          )}
          {registerTrademarkList && (
            <div className="box-wrapper">
              <PackageList
                registerTrademarkList={registerTrademarkList}
                isV3={false}
              />
            </div>
          )}
          {/* next form hided using css (.reg .packages #TrademarkForm) */}
          <Form id="TrademarkForm" noValidate validated={validated}></Form>
          {registerTrademarkList && (
            <div className="box-wrapper" style={{ marginTop: '35px' }}>
              <BasicBox
                selected={state.option === 'BASIC'}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'BASIC'
                  )[0].price
                }
                onChange={handleChange}
              />
              <DeluxeBox
                selected={state.option === 'DELUXE'}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'DELUXE'
                  )[0].price
                }
                onChange={handleChange}
              />
              <PremierBox
                selected={state.option === 'PREMIER'}
                price={
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'PREMIER'
                  )[0].price
                }
                onChange={handleChange}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
